module.exports = __webpack_public_path__ + "img/1.b51ee398.jpg";